import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../baseQuery";
import { TaskExecution, PaginatedTaskExecutionResponse } from "./models";

export const taskHubExecutionApi = createApi({
  baseQuery,
  reducerPath: "taskHubApiExecution",
  tagTypes: ["Tasks-Execution"],
  endpoints: (builder) => ({
    getTasksExecution: builder.query<TaskExecution[], any>({
      query: (params) => ({
        url: "/api/v1/taskexecutions/",
        method: "GET",
        params,
      }),
      transformResponse: (
        response: TaskExecution[] | PaginatedTaskExecutionResponse
      ) => {
        if (Array.isArray(response)) {
          return response;
        }
        return response.results || [];
      },
      providesTags: ["Tasks-Execution"],
    }),
    updateTaskExecution: builder.mutation<
      TaskExecution,
      { id: number; data: Partial<TaskExecution> }
    >({
      query: ({ id, data }) => ({
        url: `/api/v1/taskexecutions/${id}/`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Tasks-Execution"],
    }),
  }),
});

export const { useGetTasksExecutionQuery, useUpdateTaskExecutionMutation } =
  taskHubExecutionApi;
